<h5 translate>You have too many internal links</h5>
<p translate>We recommend that you have no more than 100 internal links on each page.
</p>
